var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"step1 active start-verification\"><div class=\"step1-content\"><img" + (jade.attr("src", require('./../../../images/verification_required.png'), true, true)) + " alt=\"\" class=\"verification_required\"><h2>Verification Required</h2><p><a href=\"#\">{{ application.landlord.display_email }}</a> has requested to run screening reports on you.</p><p>In order to process the requested reports, we need additional information to verify your identity.</p><div class=\"cf\"></div><a href=\"#\" ng-click=\"go_to_next()\" class=\"continue apply-next-payverif1\">Continue</a><div class=\"cf\"></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/payment/start/start.jade
// module id = 1147
// module chunks = 0